<div class="modal-header" id="material-quote-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_SALES_QUOTE_TITLE"></h3>
    <span class="close" (click)="!isLoading && saveSalesQuote()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="materialQuoteForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-6 col-form-label text-start text-sm-end"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_TECH_IDENT_NUMBER"
                ></label>
                <div class="col-sm-7 col-6 text-sm-start text-end">
                    <div class="user-select-auto form-control-plaintext px-0">{{ model.techIdentNumber.value }}</div>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-start text-sm-end"
                    for="contact"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_CONTACT"
                ></label>
                <div class="col-sm-7">
                    <pace-core-text-input
                        id="contact"
                        name="contact"
                        [parentForm]="formChildren"
                        [(model)]="model.contactPerson"
                        [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_CONTACT' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-start text-sm-end"
                    for="dropdownEquip"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_EQUIP"
                ></label>
                <div class="col-sm-7">
                    <pace-core-dropdown
                        id="dropdownEquip"
                        [(model)]="model.equipments"
                        [isReadonlyInputControl]="isLoading"
                        [parentForm]="formChildren"
                        (valueChange)="model.updateTechIdentNumber()"
                    ></pace-core-dropdown>
                </div>
            </div>
            <div class="row mb-sm-3">
                <label
                    class="col-sm-4 col-form-label text-start text-sm-end"
                    for="dropdownQuoteType"
                    translate="DASHBOARD_SIDEMENU_SALES_QUOTE_TYPE"
                ></label>
                <div class="col-sm-7">
                    <pace-core-dropdown
                        (valueChange)="quoteTypeChange()"
                        id="dropdownQuoteType"
                        [ngClass]="{ 'readonly-input-control': isLoading }"
                        [parentForm]="formChildren"
                        [(model)]="model.quoteTypes"
                    ></pace-core-dropdown>
                </div>
            </div>

            @if (displayLText) {
                <div class="row mb-sm-3">
                    <label
                        class="col-sm-4 col-form-label text-start text-sm-end"
                        for="lTextSet"
                        translate="DASHBOARD_SIDEMENU_SALES_QUOTE_FREETEXT"
                    ></label>
                    <div class="col-sm-7">
                        <pace-core-text-input
                            id="lTextSet"
                            name="lTextSet"
                            [parentForm]="formChildren"
                            [(model)]="model.lTextSet"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_FREETEXT' | translate"
                        >
                        </pace-core-text-input>
                    </div>
                </div>
            }

            @if (displaySeparator) {
                <hr class="separator" />
            }
            @if (displayTimeFields) {
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-5 col-form-label text-start text-sm-end"
                        for="timeUsed"
                        translate="DASHBOARD_SIDEMENU_SALES_QUOTE_USED_TIME"
                    ></label>
                    <div class="col-md-3 col-sm-4 col-7">
                        <pace-core-number-stepper
                            id="timeUsed"
                            name="timeUsed"
                            [parentForm]="formChildren"
                            [(model)]="model.timeUsed"
                            class="col-sm-2"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_USED_TIME' | translate"
                        >
                        </pace-core-number-stepper>
                    </div>
                </div>
            }
            @if (displayTimeFields) {
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-5 col-form-label text-start text-sm-end"
                        for="timeNeed"
                        translate="DASHBOARD_SIDEMENU_SALES_QUOTE_ADD_TIME"
                    >
                    </label>
                    <div class="col-md-3 col-sm-4 col-7">
                        <pace-core-number-stepper
                            id="timeNeed"
                            name="timeNeed"
                            [parentForm]="formChildren"
                            [(model)]="model.timeNeed"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_ADD_TIME' | translate"
                        >
                        </pace-core-number-stepper>
                    </div>
                </div>
            }

            @if (displayOverallDistance) {
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-5 col-form-label text-start text-sm-end"
                        for="distance"
                        translate="DASHBOARD_SIDEMENU_SALES_QUOTE_DISTANCE"
                    ></label>
                    <div class="col-md-3 col-sm-4 col-7">
                        <pace-core-number-input
                            id="distance"
                            name="distance"
                            [parentForm]="formChildren"
                            [(model)]="model.distance"
                            [ariaLabel]="'DASHBOARD_SIDEMENU_SALES_QUOTE_DISTANCE' | translate"
                        >
                        </pace-core-number-input>
                    </div>
                </div>
            }

            <hr class="separator" />
            <label
                class="col-form-label text-start"
                for="existingRecipients"
                translate="DASHBOARD_SIDEMENU_SALES_QUOTE_RECIPIENTS"
            ></label>
            <div class="row mb-3 d-flex g-2">
                <pace-recipient-list
                    id="existingRecipients"
                    [parentForm]="formChildren"
                    [model]="model.existingRecipients"
                ></pace-recipient-list>
            </div>
            <hr class="separator" />
            <div class="row mb-3 d-flex g-2">
                <label class="col-form-label text-start" translate="DASHBOARD_SIDEMENU_SALES_QUOTE_MATERIAL"></label>
                <div>
                    <pace-cse-material-list
                        id="materialList"
                        [parentForm]="formChildren"
                        [process]="processIndicator"
                        [model]="model.materialList"
                    ></pace-cse-material-list>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    @if (model.sparePartsCatalogLink && !isLoading) {
        <div class="me-auto" paceCoreLink>
            <a
                class="btn btn-primary pace-link"
                href="{{ model.sparePartsCatalogLink }}"
                target="_blank"
                translate="SPARE_PARTS_CATALOG_LINK_LABEL"
            ></a>
        </div>
    }
    @if (!isLoading) {
        <button
            class="btn btn-secondary"
            type="button"
            (click)="deleteSalesQuote()"
            translate="DASHBOARD_SIDEMENU_SALES_QUOTE_CANCEL"
        ></button>
    }
    @if (!isLoading) {
        <button
            class="btn btn-primary"
            type="button"
            (click)="sendQuote()"
            [disabled]="materialQuoteForm.invalid"
            translate="DASHBOARD_SIDEMENU_SALES_QUOTE_CREATE"
        ></button>
    }
    @if (isLoading) {
        <progressbar [striped]="true" [value]="100" type="default">Sending request... </progressbar>
    }
</div>
